export default function GalleryIntro() {
  const stats = [
    { icon: "ri-building-2-line", value: "9+", label: "Developments" },
    { icon: "ri-map-pin-2-line", value: "Sarjapur Road", label: "Prime Location" },
    { icon: "ri-home-4-line", value: "500+", label: "Plots Delivered" },
    { icon: "ri-shield-check-line", value: "10+", label: "Years of Trust" },
  ];

  return (
    <section className="py-14 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          <div className="w-full lg:w-1/2">
            <div className="inline-flex items-center gap-2 bg-[#EAF5E1] text-[#7FBF3F] text-xs font-semibold px-4 py-1.5 rounded-full mb-5 uppercase tracking-wider">
              <i className="ri-gallery-line"></i>Our Visual Portfolio
            </div>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#212121] mb-5 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              A Window Into Our Residential Work
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              This gallery showcases the residential work of Urban Infra — from construction progress and site development to completed villa plots and landscaped communities on Sarjapur Road. Every image reflects our commitment to quality, planning, and long-term value.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-7">
              Browse through the full gallery to get a complete picture of what we build and how we build it.
            </p>
            <a href="/urbaninfra" className="inline-flex items-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white text-sm font-semibold px-7 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-building-2-line"></i>View Projects
            </a>
          </div>

          <div className="w-full lg:w-1/2 grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="bg-[#FAFAFA] rounded-xl p-6 border border-[#7FBF3F]/10 flex flex-col items-center text-center hover:border-[#7FBF3F]/30 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg border border-[#7FBF3F]/20 mb-3">
                  <i className={`${s.icon} text-xl text-[#7FBF3F]`}></i>
                </div>
                <p className="font-serif text-3xl font-bold text-[#1B2A4A] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</p>
                <p className="text-gray-500 text-sm">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
